import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLeftRight"><Path fillRule="evenodd" clipRule="evenodd" d="M16.2501 21.8105L21.3108 16.7499L16.2501 11.6892L15.1895 12.7499L18.4395 15.9999L3.00011 15.9999L3.00011 17.4999H18.4395L15.1895 20.7499L16.2501 21.8105ZM8.81077 11.2499L5.56077 7.99989L21.0001 7.99989L21.0001 6.49989L5.56077 6.49989L8.81077 3.24989L7.75011 2.18923L2.68945 7.24989L7.75011 12.3105L8.81077 11.2499Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftRight;
